import { create } from 'zustand';

export type ToastVariant = 'success' | 'danger' | 'warning' | 'info';

export interface Toast {
    id: string;
    message: string;
    variant: ToastVariant;
    duration: number;
}

interface ToastState {
    toasts: Toast[];
    addToast: (message: string, variant: ToastVariant, duration?: number) => string;
    removeToast: (id: string) => void;
}

let nextId = 0;

export const useToastStore = create<ToastState>((set) => ({
    toasts: [],

    addToast: (message, variant, duration = 4000) => {
        const id = `toast-${++nextId}`;
        set((state) => ({
            toasts: [...state.toasts, { id, message, variant, duration }],
        }));
        return id;
    },

    removeToast: (id) => {
        set((state) => ({
            toasts: state.toasts.filter((t) => t.id !== id),
        }));
    },
}));

export default useToastStore;
